/** @format */

import { createRoutingAction } from 'utils/routing';

export const GoToLandingPage = createRoutingAction('GO_TO_LANDING_PAGE');
